export const SECTION_NAME = "Customer";

export const INTRO_TEXT = ``;

export const EXAMPLE_JSON = `{
    "id": 123,
    "starred": 0,
    "syncToken": 0,
    "name": "ABC Plastics",
    "fullname": "",
    "parent": {
      "id": 311,
      "name": "ABC Products/ABC Plastics"
    },
    "sublevel": 1,
    "email": "mike@abcplastics.com",
    "website": "https://abc.com",
    "phone": "817-555-1212",
    "mobile": "817-555-2121",
    "altPhone": null,
    "fax": null,
    "companyName": "ABC Plastic Products, Inc.",
    "contact" {
      "title": "Mr",
      "firstName": "Mike",
      "lastName": "Mills",
      "suffix": null
    },
    "billing": {
      "line1": "123 Main St",
      "line2": null,
      "line3": null,
      "line4": null,
      "line5": null,
      "city": "Syracuse",
      "stateProvince": "NY",
      "postalCode": "13202",
      "country": "US"
    },
    "shipping": {
      "line1": "123 Main St",
      "line2": null,
      "line3": null,
      "line4": null,
      "line5": null,
      "city": "Syracuse",
      "stateProvince": "NY",
      "postalCode": "13202",
      "country": "US"
    },
    "terms": {
      "id": 11,
      "name": "NET 30"
    },
    "priceTier": {
      "id": 21,
      "name": "A2"
    },
    "paymentMethod": {
      "id": 7,
      "name": "Check"
    },
    "salesRep": {
      "id": 19,
      "name": "Sally Sails"
    },
    "customerType": {
      "id": 3,
      "name": "Wholesale"
    },
    "resaleNumber": "B4829-91941",
    "contractorNumber": null,
    "businessLicense": null,
    "foundUsVia": "I-70 billboard",
    "currency": {
      "id": 42,
      "name": "USD"
    },
    "tax": {
      "taxable": true,
      "taxCode": {
        "id": 5,
        "name": "Sales Tax"
      }
    },
    "creditHold": false,
    "billWithParent": true,
    "lastSync": "2019-10-22T00:00:00",
    "syncMessage": "",
    "notes": null,
    "customFields": [
      {
        "id": 5,
        "name": "Checkbox",
        "value": "false",
        "dataType": "Boolean"
      },
      {
        "id": 13,
        "name": "Cust-Acct-No",
        "value": null,
        "dataType": "Number"
      }
    ],
    "altAddresses": [],
    "archived": false,
    "hasChildren": false,
    "summaryOnly": false,
  }`;

export const ATTRIBUTES = [
  {
    name: "id",
    type: "integer",
    description:
      "Unique identifier for this record. Must not be provided when creating a customer.",
  },
  {
    name: "starred",
    type: "integer",
    description: `Indicates if this customer has been starred. A value of 0 = no star; 1 or 1-3 = starred. Star colors 
      depend on application configuration. This could be 1 color of star or 3 colors of star. See 
      company setting in the user guide for more details.`,
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record. If you receive an error when updating a record, it is because your syncToken is for an older version of the record than that which is currently in the database. Please GET the latest version prior to updating.`,
  },
  {
    name: "name",
    type: "string",
    description: `The name by which you look up this customer.`,
  },
  {
    name: "fullname",
    type: "string",
    description: `Customer name with parent added.`,
    readOnly: true,
  },
  {
    name: "parent",
    type: "reference",
    description: `Refers to the parent customer of this customer record.`,
  },
  {
    name: "sublevel",
    type: "integer",
    description: `The number of levels between this customer and the highest-level customer.`,
    readOnly: true,
  },
  {
    name: "email",
    type: "string",
    description: `Self-explanatory.`,
  },
  {
    name: "website",
    type: "string",
    description: `Include the entire address, like "http://www.acompany.com".`,
  },
  {
    name: "phone",
    type: "string",
    description: `Self-explanatory. No format is enforced.`,
  },
  {
    name: "altPhone",
    type: "string",
    description: `Self-explanatory. No format is enforced.`,
  },
  {
    name: "fax",
    type: "string",
    description: `Self-explanatory. No format is enforced.`,
  },
  {
    name: "companyName",
    type: "string",
    description: `Self-explanatory.`,
  },
  {
    name: "contact",
    type: "contact",
    description: `The person to contact regarding this customer.`,
  },
  {
    name: "billing",
    type: "company address",
    description: `The customer's billing address.`,
  },
  {
    name: "shipping",
    type: "company address",
    description: `Customer's shipping address.`,
  },
  {
    name: "terms",
    type: "reference",
    description: `Payment terms.`,
  },
  {
    name: "priceTier",
    type: "reference",
    description: `The price tier to which this customer has been assigned.`,
  },
  {
    name: "paymentMethod",
    type: "reference",
    description: `The default method of payment for this customer.`,
  },
  {
    name: "salesRep",
    type: "reference",
    description: `Sales representative for this customer.`,
  },
  {
    name: "customerType",
    type: "reference",
    description: `Customer type assigned to this customer.`,
  },
  {
    name: "resaleNumber",
    type: "string",
    description: `Self-explanatory.`,
  },
  {
    name: "contractorNumber",
    type: "string",
    description: `Self-explanatory.`,
  },
  {
    name: "businessLicense",
    type: "string",
    description: `Self-explanatory.`,
  },
  {
    name: "foundUsVia",
    type: "string",
    description: `The advertising or marketing avenue that led the customer to your business.`,
  },
  {
    name: "currency",
    type: "reference",
    description: `Currency used for customer, if multicurrency is enabled.`,
  },
  {
    name: "tax",
    type: "customer tax status",
    description: `Indicates whether the customer is taxable and, if so, the tax type.`,
  },
  {
    name: "taxExemptReasonId",
    type: "string",
    description: `If you sync SOS Inventory with QuickBooks and your account is enabled for automated sales tax, you must provide a tax exempt reason ID on creates and updates, if the customer is not taxable. See the SOS Inventory or QuickBooks documentation or the respective applications for the list of valid 1- or 2-digit codes (as a string).`,
  },
  {
    name: "creditHold",
    type: "boolean",
    description: `True if customer is currently on credit hold, false if not.`,
  },
  {
    name: "billWithParent",
    type: "boolean",
    description: `True if customer is to be billed with the parent customer. If false, this customer will be billed separately.`,
  },
  {
    name: "lastSync",
    type: "date",
    newField: "New October 2nd",
    description: `The last successful sync time (GMT) for this customer, if syncronizing with Quickbooks.`,
    readOnly: true,
  },
  {
    name: "syncMessage",
    type: "string",
    newField: "New October 2nd",
    description: `The sync error message if the last sync attempt failed with Quickbooks. This will be empty if synchronization is successful.`,
    readOnly: true,
  },
  {
    name: "notes",
    type: "string",
    description:
      "The company’s internal notes about the customer. These notes are not visible to the customer.",
  },
  {
    name: "customFields",
    type: "array of custom fields",
    description: `The list of custom fields for this object type.`,
  },
  {
    name: "altAddresses",
    type: "array of customer addresses",
    description: `See billing or shipping addresses for address format.`,
  },
  {
    name: "archived",
    type: "boolean",
    description: `True if item is archived, false if not.`,
    readOnly: true,
  },
  {
    name: "hasChildren",
    type: "boolean",
    description: `True if “child” customer records are associated with this customer, false if not.`,
    readOnly: true,
  },
  {
    name: "summaryOnly",
    type: "boolean",
    description: `Indicates if the summary parameter was set when retrieving back this record`,
    readOnly: true,
  },
];

export const LINE_ITEM = [];

export const QUERY_PARAMS = [
  {
    name: "start",
    type: "number",
    description: `A cursor used in pagination.  This is the row number of the full set of results. 
     The API limits results to a max of 200 results per call.  If you want to retrieve the next set
      of results you can use this parameter to retrive the next set of results.  For example if you
       are retrieving 200 results at a time, you can set start=201 to retrieve the next page of results.`,
  },
  {
    name: "maxresults",
    type: "number",
    description: `The maximum number of results you want to return.  The default is 200, the maximum value allowed.`,
  },
  {
    name: "summary",
    type: "",
    description: `If this parameter is present (the value doesn't matter, and doesn't need to be
     specified), only the summary attributes of the estimate will be returned.`,
  },
  {
    name: "query",
    type: "string",
    description: `This parameter will filter the results by matches of the string on the following fields: name, fullName, or notes.`,
  },
  {
    name: "name",
    type: "string",
    description: `This parameter will filter the results by matches of the name or fullname fields.`,
  },
  {
    name: "email",
    type: "string",
    description: `This parameter will filter the results by matches of the customer's email.`,
  },
  {
    name: "archived",
    type: "string: yes/no",
    description: `A "yes" returns archived records only; a "no" returns only those that have not been archived.`,
  },
  {
    name: "createdsince/updatedsince",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS ",
    description: `Filters transactions created or updated since a specified date/time.`,
  },
];

export const SAMPLE_QUERY_REQUEST =
  "/api/v2/customer?start=101&maxresults=100&summary=yes&archived=no&createdsince=2019-09-10T00:00:00&updatedsince=2019-09-10T23:59:59";
